module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-regular.22e246f.eot";